import React, { useState, useEffect } from 'react';
import { Redirect, Route } from 'react-router-dom';
import { useAuthorizationContext } from '../components/AuthorizationProvider/AuthorizationProvider';
import GridLoadingSpinner from '../components/GridLoadingSpinner/GridLoadingSpinner';
import { usePlantAndLinesStore } from '../providers/PlantAndLinesStore/PlantAndLinesStore';
import { getAllowedOperations } from '../utils/authUtils';

const PrivateRoute = ({
  component: Component,
  componentProps,
  resource,
  operation,
  children,
  ...rest
}) => {
  const { isAuthenticated, user, authPolicies } = useAuthorizationContext();
  const [plant] = usePlantAndLinesStore().plantState;
  const [line] = usePlantAndLinesStore().lineState;

  const [isGivenOperationAllowed, setIsGivenOperationAllowed] = useState(false);

  useEffect(() => {
    if (resource) {
      const allowedOperations = getAllowedOperations(
        plant,
        line,
        [resource],
        authPolicies,
      );
      setIsGivenOperationAllowed(
        allowedOperations.map(i => i.operation).includes(operation),
      );
    } else {
      setIsGivenOperationAllowed(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [plant, line, authPolicies, operation, user?.isLoaded, resource]);

  const renderComponents = () => {
    if (Component) return <Component {...componentProps} />;
    return children;
  };

  return (
    <Route
      {...rest}
      render={() =>
        isAuthenticated && user?.isLoaded ? (
          isGivenOperationAllowed ? (
            renderComponents()
          ) : (
            <Redirect to="/" />
          )
        ) : (
          <div
            style={{
              margin: '40vh auto',
              height: '20vh',
              width: '20vh',
              textAlign: 'center',
            }}
          >
            <GridLoadingSpinner />
          </div>
        )
      }
    />
  );
};

export default PrivateRoute;
